import { type ChangeEvent, useState } from "react";

import type { MobileDisplayType } from "../../types";

export type MobileViewOnChange = {
  onChangeResultType: (type: MobileDisplayType) => void;
};

export const useMobileView = ({ onChangeResultType }: MobileViewOnChange) => {
  const [mobileView, setMobileView] = useState<"map" | "list">("map");

  const onMobileViewChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as MobileDisplayType;
    setMobileView(value);
    onChangeResultType(value);
  };

  return {
    mobileView,
    onMobileViewChange,
  };
};
